import $ from 'jquery';
import Slick from 'vue-slick';
import 'slick-carousel/slick/slick.scss';

import { i18n } from '../../translation.js';
import template from './socialfeed-slider.vhtml';

export default {
	components: {
		Slick,
	},
	template,
	props: {
		callOutLink: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			page: 1,
			perPage: 4,
			feed: [],
			isLoading: false,
			slickOptions: {
				slidesToShow: 4,
				slidesToScroll: 4,
				infinite: false,
				arrows: false,
				responsive: [
					{
						breakpoint: 1024,
						settings: {
							slidesToShow: 3,
							slidesToScroll: 3,
						}
					},
					{
						breakpoint: 756,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2,
						}
					},
				],
			},
		};
	},
	computed: {
		showSlick() {
			return this.feed.length > 0;
		},
		showRightArrow() {
			return this.page != 1;
		},
		showLeftArrow() {
			return this.page * this.perPage < this.feed.length;
		},
	},
	methods: {
		reload() {
			this.isLoading = true;
			getItems( this.postType, this.filters )
			.then( items => {
				if ( items ) {
					let arr = JSON.parse(items);
					this.feed = arr.feed
				}
			})
			.always( () => this.isLoading = false );
		},
		next() {
			this.page += 1;
			this.$refs.slick.next();
		},
		prev() {
			this.page -= 1;
			this.$refs.slick.prev();
		},
		swipe(e, slick, direction) {
			if ( direction == 'left' && this.feed.length > this.page * this.perPage ) {
				this.page += 1;
				this.$refs.slick.next();
			} else if ( direction == 'right' && this.page != 1 ) {
				this.page -= 1;
				this.$refs.slick.prev();
			}
		},
	},
	created() {
		this.reload();
	},
	mounted() {
		const width = $(window).width();
		if ( width < 756 ) {
			this.perPage = 2;
		} else if ( width < 1024 ) {
			this.perPage = 3;
		}
	},
};

/**
 * Gets resumes from WP REST API
 *
 * @param {string} post_type
 * @param {string} [search=""]
 * @returns {JQueryPromise<any>}
 */
function getItems() {
	const params = {
		'limit': 12,
	};

	return $.get( `https://api.socialfeeds.qnty.dk/feed/kristensen/instagram`, params );
}



// WEBPACK FOOTER //
// ./assets/_js/components/socialfeed-slider/socialfeed-slider.js